<template>
  <q-page padding>
    <div style="align-items: center" class="row col-12">
      <p class="text-h6 text-brand-1 text-weight-bold">
        Logs de Notificações enviadas
      </p>
      <p class="q-ml-sm text-brand-5">- envios de email pelo sistema</p>
    </div>
    <div>
      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-2">
          Notificação:
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.notificacao"
          />
        </div>
        <div class="col-md-2 q-ml-sm">
          Data Inicial
          <q-input
            dense
            class="input-new-design"
            outlined
            mask="##/##/####"
            v-model="filtros.dataInicial"
            :rules="[(val) => validarDataEmissao(val) || 'Data Invalida']"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataInicial"
                    :rules="[
                      (val) =>
                        val == '' ||
                        val.length == 10 ||
                        'Digite a Data Completa',
                    ]"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-2 q-ml-sm">
          Data Final
          <q-input
            dense
            class="input-new-design"
            outlined
            mask="##/##/####"
            v-model="filtros.dataFinal"
            :rules="[(val) => validarDataEmissao(val) || 'Data Invalida']"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataFinal"
                    :rules="[
                      (val) =>
                        val == '' ||
                        val.length == 10 ||
                        'Digite a Data Completa',
                    ]"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-2 q-ml-sm">
          Usuário:
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.solicitante"
          />
        </div>
      </div>

      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        dense
        :columns="columns"
        v-model:pagination="pagination"
        class="tabela-tamanho-fixo q-mt-md"
        row-key="name"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Todas de Notificações: {{ logsQuantidade }}</span
          >
        </template>
        <template #body-cell-content="props">
          <q-td style="white-space: normal">
            <p>
              {{ props.row.content }}
            </p>
          </q-td>
        </template>
        <template #body-cell-updated_at="props">
          <q-td>
            <div>
              {{ props.row.data.split(" ")[0].split("-").reverse().join("/") }}
            </div>
            <div class="q-pl-sm">
              {{ props.row.data.split(" ")[1] }}
            </div>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "nome_usario",
    label: "Usuário",
    field: "nome_usario",
    align: "left",
  },
  {
    name: "matricula",
    label: "ID",
    field: "matricula",
    align: "left",
  },
  {
    name: "notificacao",
    label: "Alerta",
    field: "notificacao",
    align: "left",
  },
  {
    name: "display_name",
    label: "Descrição Alerta",
    field: "display_name",
    align: "left",
  },
  {
    name: "status_envio",
    label: "Status",
    align: "left",
    field: "status_envio",
  },
  {
    name: "updated_at",
    label: "Data Envio",
    field: "updated_at",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { watchDebounced } from "@vueuse/core";
import { ref, onMounted, computed } from "vue";
import { validarDataEmissao } from "../../../helpers/dateValidation";
export default {
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const filtros = ref({
      notificacao: "",
      dataInicial: "",
      dataFinal: "",
      solicitante: "",
    });
    const disable = ref(true);
    const logsQuantidade = ref(0);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const getDados = async (page = 0, rowsPerPage = 15) => {
      try {
        let response = await store.dispatch("configuracao/getLogsNotificacao", {
          data_inicial: await verifyValue(filtros.value.dataInicial),
          data_final: await verifyValue(filtros.value.dataFinal),
          pessoa: await verifyValue(filtros.value.solicitante),
          notificacao: await verifyValue(filtros.value.notificacao),
          page: page,
          per_page: rowsPerPage,
        });

        rows.value = response.data.result.data;

        pagination.value.rowsPerPage = response.data.result.per_page;
        pagination.value.rowsNumber = response.data.result.total;
        logsQuantidade.value = response.data.result.total;
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watchDebounced(
      [
        () => pagination.value.page,
        () => filtros.value.dataInicial,
        () => filtros.value.dataFinal,
        () => filtros.value.solicitante,
        () => filtros.value.notificacao,
      ],
      () => {
        if (
          filtros.value.dataInicial != "" &&
          filtros.value.dataInicial.length != 10
        ) {
          return;
        }
        if (
          filtros.value.dataFinal != "" &&
          filtros.value.dataFinal.length != 10
        ) {
          return;
        }
        disable.value = true;
        handleRequest();
      },
      { debounce: 400 }
    );

    const verifyValue = async (value) => {
      if (value != "") {
        return value;
      } else {
        return undefined;
      }
    };

    return {
      rows,
      columns,
      getDados,
      handleRequest,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      pagination,
      disable,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      logsQuantidade,
      filtros,
      verifyValue,
      validarDataEmissao,
    };
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.button-link {
  cursor: pointer;
  color: #0000ff;
  text-decoration: underline;
}
</style>
